import { Flex, Switch as SwitchChakra, Text} from '@chakra-ui/react';
import { Visible } from 'components';


type SwitchProps = {
    defaultChecked?: boolean;
    disabled?: boolean;
    size?: string;
    label?: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const Switch = ({
    disabled = false,
    size = 'lg',
    label,
    defaultChecked = false,
    onChange
}: SwitchProps) => {
    return (
      <Flex justifyContent={label ? 'space-between' : ''}>
      <Visible when={!!label}>
        <Text>{label}</Text>
      </Visible>
        <SwitchChakra
            defaultChecked={defaultChecked}
            isDisabled={disabled}
            onChange={onChange}
            size={size}
        />
      </Flex>
    )
  };

  export { Switch };